import React from 'react';
import styled from 'styled-components';

import IconContainer from 'LegacyWeployDesignLanguage/icons/IconContainer';
import JobPastSvg from 'LegacyWeployDesignLanguage/icons/JobPastIcon';

const EmptyPastJobsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledIconContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing[3]};
`;

const StyledHeading = styled.h6`
  margin-bottom: ${props => props.theme.spacing[1]};
`;

const EmptyPastJobs = () => (
  <EmptyPastJobsWrapper>
    <StyledIconContainer>
      <IconContainer svg={<JobPastSvg />} size={IconContainer.LARGE} />
    </StyledIconContainer>
    <StyledHeading>No past jobs</StyledHeading>
    <span>Past and cancelled jobs will show up here</span>
  </EmptyPastJobsWrapper>
);

export default EmptyPastJobs;
